import { Create, SimpleForm, TextInput } from 'react-admin';

export const CategoryCreate = () => (
  <Create redirect="list">
    <SimpleForm>
      <TextInput source="name" fullWidth label="Имя" />
    </SimpleForm>
  </Create>
);
